import {
  MdOpacity, // Replaced MdeFade
  MdTransform,
  MdSwapHoriz,
  MdSwapVert,
  MdBlurOn,
  MdGridView,
  MdLens,
  MdCropSquare,
  MdVerticalSplit,
  MdHorizontalSplit,
  MdCallMade,
  MdCallReceived,
  MdSouthWest,
  MdSouthEast,
  MdRadioButtonUnchecked,
  MdArrowBack,
  MdArrowForward,
  MdArrowUpward,
  MdArrowDownward,
  MdClose,
  MdOpenInNew,
  MdCompress,
  MdExpand,
  MdZoomIn,
  MdViewWeek,
  MdViewStream
} from 'react-icons/md'

import {
  RiLayoutRightLine,
  RiLayoutLeftLine,
  RiLayoutTopLine,
  RiLayoutBottomLine,
  RiShutDownLine,
  RiAppsLine
} from 'react-icons/ri'

import { BiLoaderCircle, BiScan } from 'react-icons/bi'

//https://trac.ffmpeg.org/wiki/Xfade
const TRANSITION_PREVIEWS = [
  {
    name: 'fade',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fade.gif'
  },
  {
    name: 'fadein',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fade.gif'
  },
  {
    name: 'fadeout',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fade.gif'
  },
  {
    name: 'fadefast',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fadefast.gif'
  },
  {
    name: 'fadeslow',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fadeslow.gif'
  },
  {
    name: 'fadeblack',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fadeblack.gif'
  },
  {
    name: 'fadewhite',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fadewhite.gif'
  },
  {
    name: 'fadegrays',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/fadegrays.gif'
  },
  {
    name: 'wipeleft',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipeleft.gif'
  },
  {
    name: 'wiperight',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wiperight.gif'
  },
  {
    name: 'wipeup',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipeup.gif'
  },
  {
    name: 'wipedown',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipedown.gif'
  },
  {
    name: 'wipetl',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipetl.gif'
  },
  {
    name: 'wipetr',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipetr.gif'
  },
  {
    name: 'wipebl',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipebl.gif'
  },
  {
    name: 'wipebr',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/wipebr.gif'
  },
  {
    name: 'slideleft',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/slideleft.gif'
  },
  {
    name: 'slideright',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/slideright.gif'
  },
  {
    name: 'slideup',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/slideup.gif'
  },
  {
    name: 'slidedown',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/slidedown.gif'
  },
  {
    name: 'smoothleft',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/smoothleft.gif'
  },
  {
    name: 'smoothright',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/smoothright.gif'
  },
  {
    name: 'smoothup',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/smoothup.gif'
  },
  {
    name: 'smoothdown',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/smoothdown.gif'
  },
  {
    name: 'circlecrop',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/circlecrop.gif'
  },
  {
    name: 'rectcrop',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/rectcrop.gif'
  },
  {
    name: 'circleopen',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/circleopen.gif'
  },
  {
    name: 'circleclose',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/circleclose.gif'
  },
  {
    name: 'vertopen',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vertopen.gif'
  },
  {
    name: 'vertclose',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vertclose.gif'
  },
  {
    name: 'horzopen',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/horzopen.gif'
  },
  {
    name: 'horzclose',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/horzclose.gif'
  },
  {
    name: 'dissolve',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/dissolve.gif'
  },
  {
    name: 'pixelize',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/pixelize.gif'
  },
  {
    name: 'diagtl',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/diagtl.gif'
  },
  {
    name: 'diagtr',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/diagtr.gif'
  },
  {
    name: 'diagbl',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/diagbl.gif'
  },
  {
    name: 'diagbr',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/diagbr.gif'
  },
  {
    name: 'hlslice',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/hlslice.gif'
  },
  {
    name: 'hrslice',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/hrslice.gif'
  },
  {
    name: 'vuslice',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vuslice.gif'
  },
  {
    name: 'vdslice',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vdslice.gif'
  },
  {
    name: 'hblur',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/hblur.gif'
  },
  {
    name: 'squeezeh',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/squeezeh.gif'
  },
  {
    name: 'squeezev',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/squeezev.gif'
  },
  {
    name: 'zoomin',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/zoomin.gif'
  },
  {
    name: 'hlwind',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/hlwind.gif'
  },
  {
    name: 'hrwind',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/hrwind.gif'
  },
  {
    name: 'vuwind',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vuwind.gif'
  },
  {
    name: 'vdwind',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/vdwind.gif'
  },
  {
    name: 'coverleft',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/coverleft.gif'
  },
  {
    name: 'coverright',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/coverright.gif'
  },
  {
    name: 'coverup',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/coverup.gif'
  },
  {
    name: 'coverdown',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/coverdown.gif'
  },
  {
    name: 'revealleft',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/revealleft.gif'
  },
  {
    name: 'revealright',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/revealright.gif'
  },
  {
    name: 'revealup',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/revealup.gif'
  },
  {
    name: 'revealdown',
    url: 'https://trac.ffmpeg.org/raw-attachment/wiki/Xfade/revealdown.gif'
  }
]

const SUPPORTED_TRANSITIONS = [
  'fade',
  'fadein',
  'fadeout',
  'fadeblack',
  'fadewhite',
  'dissolve',
  'wipeleft',
  'wiperight',
  'wipeup',
  'wipedown',
  'slideleft',
  'slideright',
  'slideup',
  'slidedown',
  'circlecrop',
  'circleclose',
  'circleopen',
  'rectcrop',
  'horzclose',
  'horzopen',
  'vertclose',
  'vertopen',
  'diagtl',
  'diagtr',
  'diagbl',
  'diagbr',
  'radial',
  'smoothleft',
  'smoothright',
  'smoothup',
  'smoothdown',
  'pixelize',
  'squeezeh',
  'squeezev',
  'zoomin',
  'hlslice',
  'hrslice',
  'vuslice',
  'vdslice',
  'hblur',
  'fadegrays',
  'coverleft',
  'coverright',
  'coverup',
  'coverdown',
  'revealleft',
  'revealright',
  'revealup',
  'revealdown'
]

const ICON_MAP = {
  fade: MdOpacity,
  fadein: MdOpacity,
  fadeout: MdOpacity,
  fadeblack: MdOpacity,
  fadewhite: MdOpacity,
  dissolve: BiLoaderCircle,
  wipeleft: MdArrowBack,
  wiperight: MdArrowForward,
  wipeup: MdArrowUpward,
  wipedown: MdArrowDownward,
  slideleft: RiLayoutLeftLine,
  slideright: RiLayoutRightLine,
  slideup: RiLayoutTopLine,
  slidedown: RiLayoutBottomLine,
  circlecrop: MdLens,
  circleclose: MdRadioButtonUnchecked,
  circleopen: MdRadioButtonUnchecked,
  rectcrop: MdCropSquare,
  horzclose: MdHorizontalSplit,
  horzopen: MdHorizontalSplit,
  vertclose: MdVerticalSplit,
  vertopen: MdVerticalSplit,
  diagtl: MdCallMade,
  diagtr: MdCallMade,
  diagbl: MdSouthWest,
  diagbr: MdSouthEast,
  radial: BiScan,
  smoothleft: MdArrowBack,
  smoothright: MdArrowForward,
  smoothup: MdArrowUpward,
  smoothdown: MdArrowDownward,
  pixelize: RiAppsLine, // Changed from MdAppsLine which might be invalid too, RiAppsLine is imported
  squeezeh: MdCompress,
  squeezev: MdCompress,
  zoomin: MdZoomIn,
  hlslice: MdViewWeek,
  hrslice: MdViewWeek,
  vuslice: MdViewStream,
  vdslice: MdViewStream,
  hblur: MdBlurOn,
  fadegrays: MdOpacity,
  coverleft: RiLayoutLeftLine,
  coverright: RiLayoutRightLine,
  coverup: RiLayoutTopLine,
  coverdown: RiLayoutBottomLine,
  revealleft: RiLayoutLeftLine,
  revealright: RiLayoutRightLine,
  revealup: RiLayoutTopLine,
  revealdown: RiLayoutBottomLine
}

export const transitions = SUPPORTED_TRANSITIONS.map(t => {
  const preview = TRANSITION_PREVIEWS.find(p => p.name === t)
  return {
    id: t,
    name: t.charAt(0).toUpperCase() + t.slice(1),
    icon: ICON_MAP[t] || MdTransform, // Default icon if mapping not found
    effect_type: t,
    duration: 1.0,
    previewUrl: preview ? preview.url : null
  }
})
